import { Box, Text } from '@machobear/design-system'
import { StyledTableCell } from '@/components/listings-table'
import formatDate from '@/utils/format-date'
import { RenderStatusButton, RenderBadge } from './trustscore-status'
import { OptionsMenu } from './options-menu'
import { Favourite } from './favourite-column'
import { Modals } from '../types'

type TrustScoreRowProps = {
  isBillingUserValid?: boolean
  trustScoreInfo: any
  showModal: (modal: keyof Modals) => () => void
  setDeleteId: (deleteId: string) => void
  favouriteTrustScore: () => void
}

export const TrustScoreRow = ({
  isBillingUserValid,
  trustScoreInfo,
  showModal,
  setDeleteId,
  favouriteTrustScore
}: TrustScoreRowProps) => {
  return (
    <>
      <Favourite trustScoreInfo={trustScoreInfo} favouriteTrustScore={favouriteTrustScore} />
      <StyledTableCell justifyContent="flex-start">
        <Box padding="xsmall">
          <Text size="standard">{trustScoreInfo?.name}</Text>
        </Box>
      </StyledTableCell>
      <StyledTableCell justifyContent="flex-start">
        <Box padding="xsmall">
          <Text>
            {trustScoreInfo?.last_updated !== null
              ? formatDate(trustScoreInfo?.last_updated, 'MMM D, YYYY')
              : 'N/A'}
          </Text>
        </Box>
      </StyledTableCell>
      <StyledTableCell justifyContent="flex-start">
        <Box padding="xsmall">
          <Text>
            {trustScoreInfo?.trust_score !== null
              ? `${trustScoreInfo?.trust_score}/${trustScoreInfo?.max_trust_score}`
              : 'N/A'}
          </Text>
        </Box>
      </StyledTableCell>
      <StyledTableCell>
        <Box padding="xsmall">
          <RenderBadge status={trustScoreInfo?.status} />
        </Box>
      </StyledTableCell>
      <StyledTableCell>
        <Box padding="xsmall">
          <RenderStatusButton
            showModal={showModal}
            isBillingUserValid={isBillingUserValid}
            status={trustScoreInfo?.status}
            id={trustScoreInfo?.id}
          />
        </Box>
      </StyledTableCell>

      <StyledTableCell>
        <Box padding="xsmall" marginLeft="xxxsmall">
          <OptionsMenu
            trustScoreInfo={trustScoreInfo}
            showModal={showModal}
            setDeleteId={setDeleteId}
          />
        </Box>
      </StyledTableCell>
    </>
  )
}
